export const StatsPage = () => (
  <div className="p-8">
    <h1 className="text-2xl font-semibold text-slate-900 mb-1">Статистика платформы</h1>
    <p className="text-sm text-slate-500 mb-6">Развёрнутые KPI и графики (P1 в дорожной карте).</p>

    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-sm text-amber-900 max-w-xl">
      Раздел в разработке. По спеке требуется:
      <ul className="list-disc list-inside mt-2 space-y-1">
        <li>KPI «текущие активные сессии» и «пиковое число»</li>
        <li>График «уникальные пользователи в месяц»</li>
        <li>«Среднее пользователей в день» (за последние 30 дней)</li>
        <li>Линейный график «средняя нагрузка по часам»</li>
      </ul>
      Требует трекинга сессий в Redis — см. Этап 6 в <code>docs/ROADMAP.md</code>.
    </div>
  </div>
);
